import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-report-user',
  templateUrl: './report-user.component.html',
  styleUrls: ['./report-user.component.css']
})
export class ReportUserComponent implements OnInit {

  showReport: boolean;
  report;
  items: MenuItem[] = [];
  activeTabIndex: number = 0;
  showInfo: boolean;
  infoReport: string;

  constructor(private translate: TranslateService) { }

  ngOnInit() {

    this.translate.get([
      'report.companiesAppReport',
      'report.userCompaniesAppReport',
      'report.userRolesReport',
      'report.rolesPermissionReport'
    ]).subscribe( t => {

      this.items.push({
        label: t['report.companiesAppReport'],
        command: (event: any) => {
         this.activeTabIndex = 0;
        }
      },
      {
        label: t['report.userCompaniesAppReport'],
        command: (event: any) => {
          this.activeTabIndex = 1;
        },
      },
      {
        label: t['report.userRolesReport'],
        command: (event: any) => {
          this.activeTabIndex = 2;
        }
      },
      {
        label: t['report.rolesPermissionReport'],
        command: (event: any) => {
          this.activeTabIndex = 3;
        }
      });

    });
  }


  infoReportDescription(reportInfo: string) {
    this.infoReport = reportInfo;
  }

  showInfoPopUp(show: boolean) {
    this.showInfo = show;
  }

  closeDialog() {
    this.showInfo = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-user.component.ts